import { useMemo } from 'react'

import { Box, Icon } from '@fairfashion/design-system'
import { useLocation } from 'react-router-dom'

import { routes } from '../../../../utilities/menu/routes'
import { getRoutes } from '../../header.utils'
import { BreadcrumbItem } from '../breadcrumb-item/breadcrumb-item.comp'

export const Breadcrumb = () => {
  const defaultRoute = routes.find((route) => route.url === '/dashboard')

  const pathname = useLocation().pathname

  const breadcrumbRoutes = useMemo(
    () =>
      getRoutes(pathname).filter((route) => route.url !== defaultRoute?.url),
    [pathname],
  )

  return (
    <Box gap={1} alignItems="center">
      <BreadcrumbItem {...defaultRoute!} />
      {!!breadcrumbRoutes?.length &&
        breadcrumbRoutes.map((route, index) => (
          <Box alignItems="center" key={`route-${index}`}>
            <Icon name="arrow_right_s" size={16} color="grey_4" />
            <BreadcrumbItem {...route!} />
          </Box>
        ))}
    </Box>
  )
}
